module.exports = __webpack_public_path__ + "0acd653c66bcaab2d53d35a3cf0425eb.svg";


//////////////////
// WEBPACK FOOTER
// ./images/step2-gray.svg
// module id = 1138
// module chunks = 0